import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getList } from "./CheckAPI";

const initialState = {
    prjId:'',
    prjName:'',
    checksData: {},
    apiStatus: 'idle'
}

export const getChecksDataAsync = createAsyncThunk(
    'check/getChecksDataAsync',
    async (input, thunkAPI) => {
        //const response = await login(input);
        let res;
        try {
            res = getList(input);
        } catch (e) {
            thunkAPI.rejectWithValue({ errorMessage: 'Fetch error' });
            return;
        }

        //return response.data;
        //return JSON.parse(res.json());
        return res;
    }
);

const checkListSlice = createSlice({
    name: "check",
    initialState,
    reducers: {
    },

    extraReducers: (builder) => {
        builder
            .addCase(getChecksDataAsync.pending, (state) => {
                state.apiStatus = 'loading';
            })
            .addCase(getChecksDataAsync.fulfilled, (state, action) => {
                state.apiStatus = 'idle';
                state.checksData = action.payload;
            })
            .addCase(getChecksDataAsync.rejected, (state, action) => {
                state.apiStatus = 'idle';
                state.checksData = {};
            });
    },
});


export const selectChecksData = (state) => state.check.checksData;

export default checkListSlice;